module.exports = __webpack_public_path__ + "static/images/info-grey-light.834fc9631e9ef19138f4c8e12af72843.svg";